<template>
  <b-card>
    <validation-observer
      ref="infoRules"
      v-slot="{ invalid }"
      tag="form"
    >
      <b-row>
        <b-col md="6">
          <!-- Name -->
          <validation-provider
            #default="validationContext"
            name="amount"
            rules="required"
          >
            <b-form-group
              label="amount"
              label-for="amount"
            >
              <b-form-input
                id="amount"
                v-model="loanForm.amount"
                :state="getValidationState(validationContext)"
                trim
                placeholder="amount"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col md="6">
          <!-- Name -->
          <validation-provider
            #default="validationContext"
            name="Payment Months"
            rules="required"
          >
            <b-form-group
              label="Payment Months"
              label-for="Payment Months"
            >
              <b-form-input
                id="payment_months"
                v-model="loanForm.payment_months"
                :state="getValidationState(validationContext)"
                trim
                type="number"
                min="1"
                max="100"
                placeholder="Payment Months"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>

        <!-- Server Errors -->
        <b-col
          v-if="Object.values(errors).length > 0"
          cols="12"
        >
          <p
            v-for="(error, key, index) in errors"
            :key="index"
            class="text-danger small"
          >
            {{ error.toString() }}
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          class="mt-50"
        >

          <b-button
            v-if="!loader && $route.params.id"
            variant="primary"
            class="mr-1"
            :disabled="invalid || Object.values(errors).length > 0"
            @click="editLoan()"
          >
            Save Changes
          </b-button>
          <b-button
            v-if="!loader && !$route.params.id"
            variant="primary"
            class="mr-1"
            :disabled="invalid || Object.values(errors).length > 0"
            @click="editLoan()"
          >
            Add
          </b-button>
          <b-button
            v-if="loader"
            variant="primary"
            disabled
            class="mr-1"
          >
            <b-spinner
              small
              type="grow"
            />
            Loading...
          </b-button>
        </b-col>
      </b-row>
    </validation-observer>
  </b-card>
</template>

<script>
import { ref } from '@vue/composition-api'
import formValidation from '@core/comp-functions/forms/form-validation'
import axios from 'axios'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// eslint-disable-next-line no-unused-vars
import _ from 'lodash'
import decryptData from '@/store/auth/decryptData'

export default {
  components: {
  },
  data() {
    return {
      id: this.$store.state.generalIds.id,
      required,
      allSelected: [],
      users: [],
      loader: false,
      validationErrors: {},
      errors: {},
    }
  },
  setup() {
    const { getValidationState } = formValidation()
    // eslint-disable-next-line camelcase

    const loanForm = ref({

    })
    return {
      getValidationState,
      loanForm,
    }
  },
  mounted() {
    this.showLoan()
  },
  methods: {
    showLoan() {
      if (this.$route.params.id) {
        axios.get(`loan/${this.$route.params.id}`).then(res => {
          const loanData = decryptData(res.data.payload).data
          this.loanForm = {
            amount: loanData.amount,
            payment_months: loanData.payment_months,
          }
        })
      } else {
        return false
      }
      return true
    },
    editLoan() {
      if (this.$route.params.id) {
        this.loader = true
        const formData = new FormData()
        formData.append('_method', 'PUT')
        // eslint-disable-next-line no-restricted-syntax, guard-for-in
        for (const key in this.loanForm) {
          formData.append(key, this.loanForm[key])
        }

        axios.post(`loan/${this.$route.params.id}`, formData).then(res => {
          if (res.status === 200) {
            this.$router.push({ name: 'loan' })
            this.$toasted.show('Updated Successfully', {
              position: 'top-center',
              duration: 3000,
            })
          }
        }).catch(error => {
          const payload = decryptData(error.response.data.payload).message
          const firstArrayKey = Object.keys(payload).find(key => Array.isArray(payload[key]))
          const errorMessage = firstArrayKey ? payload[firstArrayKey][0] : 'Cannot update loan in current status'
          this.$toast({
            component: ToastificationContent,
            props: {
              title: errorMessage,
              icon: 'BellIcon',
              variant: 'error',
            },
          })
        }).finally(() => {
          this.loader = false
        })
      }
    },
  },

}
</script>

  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  </style>
